<template>
  <div class="pneu-lancamento ml-4 mr-4">
    <div class="row">
      <div class="col-7">
        <div class="col-12">
          <div>
            <b-row>
              <!-- Coluna de Tamanho 8 -->
              <b-col cols="12">
                <b-col cols="12">
                  <Alerta
                    v-if="mensagemVisivel"
                    :mensagem="mensagem"
                    :tipo="tipoMensagem"
                    @close="mensagemVisivel = false"
                  />
                  <!-- DADOS DO PROCESSO                  --->
                  <!-- DADOS DO PROCESSO                  --->
                  <!-- DADOS DO PROCESSO                  --->

                  <b-row>
                    <b-col cols="3">
                      <label for="input-busca">Processo - Audiência</label>
                      <b-form-group class="mb-3">
                        <b-form-input
                          @keyup.enter="
                            limparCampos(),
                              getProcessoSintetico(nroProcesso),
                              getAudiencias(nroProcesso)
                          "
                          v-model="nroProcesso"
                          placeholder="Número do Processo"
                          v-b-tooltip.hover
                          title="Digite o número do processo"
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>

                    <!-- TIPO -->
                    <b-col cols="3" class="mb-3">
                      <label for="input-tipo">Tipo</label>
                      <b-input-group-text>
                        {{
                          processo && processo.classe_nome
                            ? processo.classe_nome
                            : "-"
                        }}
                      </b-input-group-text>
                    </b-col>

                    <!-- VARA -->
                    <b-col cols="6" class="mb-3">
                      <label for="input-busca">Vara</label>
                      <b-input-group-text
                        id="input-vara"
                        style="font-size: 0.7rem"
                      >
                        {{
                          processo && processo.orgao_julgador_nome
                            ? processo.orgao_julgador_nome
                            : "-"
                        }}
                      </b-input-group-text>
                    </b-col>

                    <div class="col-12">
                      <b-row class="mt-3 mb-3">
                        <b-row>
                          <!-- Componente de Imagem com Altura e Largura Definidas -->
                          <b-col cols="4" class="ml-3">
                            <img
                              :src="
                                funcionarios.foto_url
                                  ? funcionarios.foto_url
                                  : 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/sem-foto.jpg'
                              "
                              alt="Imagem"
                              class="img-custom"
                            />
                          </b-col>
                        </b-row>

                        <!-- Coluna de Tamanho 8 -->
                        <b-col cols="10">
                          <b-row>
                            <!-- Inputs ao lado da Imagem, empilhados verticalmente -->
                            <b-col>
                              <b-row>
                                <b-col cols="4">
                                  <VInputFlutuante
                                    :value="funcionarios.registro"
                                    label="Registro"
                                    readonly
                                  />
                                </b-col>

                                <b-col cols="8">
                                  <VInputFlutuante
                                    :value="funcionarios.funcao"
                                    label="Função"
                                    readonly
                                  />
                                </b-col>
                              </b-row>

                              <b-row>
                                <!-- Função -->

                                <b-col cols="12">
                                  <VInputFlutuante
                                    :value="funcionarios.nome_completo"
                                    label="Nome do funcionário"
                                    readonly
                                  />
                                </b-col>
                              </b-row>

                              <b-row>
                                <b-col cols="4">
                                  <VInputFlutuante
                                    :value="
                                      moment(funcionarios.dt_admissao).format(
                                        'DD/MM/YYYY'
                                      )
                                    "
                                    label="Data de Admissão"
                                    readonly
                                  />
                                </b-col>

                                <b-col cols="4">
                                  <VInputFlutuante
                                    :value="
                                      funcionarios.dt_demissao
                                        ? moment(
                                            funcionarios.dt_demissao
                                          ).format('DD/MM/YYYY')
                                        : '-'
                                    "
                                    label="Data de Demissão"
                                    readonly
                                  />
                                </b-col>

                                <b-col cols="4" class="mb-3">
                                  <VInputFlutuante
                                    :value="
                                      calcularTempoDeCasa(
                                        funcionarios.dt_admissao,
                                        funcionarios.dt_demissao
                                      )
                                    "
                                    label="Tempo de Casa"
                                    readonly
                                  />
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-col>

                        <!-- Coluna de Tamanho 4 -->
                      </b-row>
                    </div>

                    <b-col cols="2" class="mb-3">
                      <div>
                        <label for="datepicker-placeholder"
                          >Data audiência
                        </label>
                        <b-form-datepicker
                          id="dt_sol_inicial"
                          v-model="audiencia.audiencia_ini_dt"
                          placeholder="Data distribuição "
                          locale="pt-BR"
                          date-format-options="DD/MM/YYYY"
                        ></b-form-datepicker>
                      </div>
                    </b-col>

                    <b-col cols="2">
                      <label for="servico-inicio">Hora inicio</label>
                      <div>
                        <b-form-input
                          id="ini-servico"
                          v-model="audiencia.audiencia_ini_hr"
                          type="time"
                        ></b-form-input>
                      </div>
                    </b-col>

                    <b-col cols="2" class="mb-3">
                      <div>
                        <label for="datepicker-placeholder"
                          >Data audiência
                        </label>
                        <b-form-datepicker
                          id="dt_sol_inicial"
                          v-model="audiencia.audiencia_ter_dt"
                          placeholder="Data distribuição "
                          locale="pt-BR"
                          date-format-options="DD/MM/YYYY"
                        ></b-form-datepicker>
                      </div>
                    </b-col>

                    <b-col cols="2">
                      <label for="servico-inicio">Hora término</label>
                      <div>
                        <b-form-input
                          id="ini-servico"
                          v-model="audiencia.audiencia_ter_hr"
                          type="time"
                        ></b-form-input>
                      </div>
                    </b-col>

                    <b-col cols="4">
                      <label for="input-busca" class="mb-4"></label>
                      <VInputFlutuante
                        v-model="audiencia.juiz"
                        label="Juiz"
                        type="text"
                      />
                    </b-col>

                    <LoadingModal v-if="isLoading" />
                  </b-row>

                  <!-- fase -->
                  <b-row class="g-3">
                    <!-- Função -->

                    <b-col cols="3" class="mb-2">
                      <label for="input-busca">Fase</label>

                      <b-input-group-text>
                        {{ processo && processo.fase ? processo.fase : "-" }}
                      </b-input-group-text>
                    </b-col>
                    <!-- natureza -->

                    <b-col cols="3" class="mb-2">
                      <label for="input-busca">Natureza</label>

                      <b-input-group-text>
                        {{
                          processo && processo.natureza
                            ? processo.natureza
                            : "-"
                        }}
                      </b-input-group-text>
                    </b-col>

                    <b-col cols="3">
                      <label for="input-grupo">Tipo da audiência</label> -
                      <div>
                        <b-form-select
                          id="escritorioAtribuido"
                          v-model="audiencia.tipo_id"
                          :options="tipos"
                          class="mb-3"
                          text-field="tipo"
                        >
                        </b-form-select>
                      </div>
                    </b-col>

                    <!-- STATUS DO PROCESSO -->
                    <b-col cols="3">
                      <label for="input-grupo">Status da audiência</label>
                      <div>
                        <b-form-select
                          id="advogadoReclamante"
                          v-model="audiencia.status_id"
                          :options="statuss"
                          class="mb-3"
                          text-field="status"
                        >
                        </b-form-select>
                      </div>
                    </b-col>
                  </b-row>

                  <!-- ESCRITO E ADVOGADO DO RECLAMANTE -->
                  <b-row>
                    <b-col cols="3">
                      <label for="input-grupo">Escritório atribuído</label> -
                      <div>
                        <b-form-select
                          id="escritorioAtribuido"
                          v-model="audiencia.escritorio_atribuido_id"
                          @change="getAdvogadoAtribuido()"
                          :options="escritoriosatribuido"
                          class="mb-3"
                          text-field="fantasia"
                        >
                        </b-form-select>
                      </div>
                    </b-col>

                    <!-- STATUS DO PROCESSO -->
                    <b-col cols="3">
                      <label for="input-grupo">Advogado Atribuído</label>
                      <div>
                        <b-form-select
                          id="advogadoReclamante"
                          v-model="audiencia.escritorio_atribuido_advogado_id"
                          :options="advogadoAtribuido"
                          class="mb-3"
                          text-field="nome"
                        >
                        </b-form-select>
                      </div>
                    </b-col>

                    <b-col cols="3">
                      <label for="input-grupo"
                        >Escritório do Advogado do Reclamante</label
                      >
                      <div>
                        <b-form-select
                          id="escritorioReclamante"
                          v-model="audiencia.escritorio_reclamante_id"
                          @change="getAdvogadoReclamante()"
                          :options="escritoriosreclamante"
                          class="mb-3"
                          text-field="fantasia"
                        >
                        </b-form-select>
                      </div>
                    </b-col>
                    <!-- STATUS DO PROCESSO -->
                    <b-col cols="3">
                      <label for="input-grupo">Advogado do Reclamante</label>
                      <div>
                        <b-form-select
                          id="advogadoReclamante"
                          v-model="audiencia.escritorio_reclamante_advogado_id"
                          :options="advogadoReclamante"
                          class="mb-3"
                          text-field="nome"
                        >
                        </b-form-select>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="6">
                      <VInputFlutuante
                        v-model="audiencia.preposto"
                        label="Preposto"
                        type="text"
                      />
                    </b-col>

                    <b-col cols="6">
                      <VInputFlutuante
                        v-model="audiencia.testemunha"
                        label="Testemunha"
                        type="text"
                      />
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Valor da proposta</label>
                      <VMoeda
                        v-model="audiencia.vlrproposta"
                        placeholder=""
                        title="Informe o valor do produto"
                      />
                    </b-col>

                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Valor da causa</label>
                      <VMoeda
                        v-model="audiencia.vlrcausa"
                        placeholder=""
                        title="Informe o valor do produto"
                      />
                    </b-col>

                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Valor Juizo</label>
                      <VMoeda
                        v-model="audiencia.vlrjuizo"
                        placeholder=""
                        title="informe o valor do produto"
                      />
                    </b-col>

                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Valor sentença</label>
                      <VMoeda
                        v-model="audiencia.vlrsentenca"
                        placeholder=""
                        title="informe o valor do produto"
                      />
                    </b-col>

                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Valor reclamante</label>
                      <VMoeda
                        v-model="audiencia.vlrreclamante"
                        placeholder=""
                        title="informe o valor do produto"
                      />
                    </b-col>

                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Valor rescisão</label>
                      <VMoeda
                        v-model="audiencia.vlrrescisao"
                        placeholder=""
                        title="informe o valor do produto"
                      />
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <b-form-textarea
                        id="infoConteudo"
                        v-model="audiencia.detalhamento_audiencia"
                        size="sm"
                        rows="4"
                        placeholder="Observações da audiência"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>

                  <!--- DESPESAS NA AUDIENCIA --->
                  <!--- DESPESAS NA AUDIENCIA --->
                  <!--- DESPESAS NA AUDIENCIA --->
                  <b-row>
                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Valor com alimentação</label>
                      <VMoeda
                        v-model="audiencia.vlr_desp_alimentacao"
                        placeholder=""
                        title="Gastos com alimentação"
                      />
                    </b-col>

                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Valor transporte</label>
                      <VMoeda
                        v-model="audiencia.vlr_desp_transporte"
                        placeholder=""
                        title="Gastos com transporte"
                      />
                    </b-col>

                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro"
                        >Valor com estacionamento</label
                      >
                      <VMoeda
                        v-model="audiencia.vlr_desp_estacionamento"
                        placeholder=""
                        title="Gastos com estacionamento"
                      />
                    </b-col>

                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Valor com combustivel</label>
                      <VMoeda
                        v-model="audiencia.vlr_desp_combustivel"
                        placeholder=""
                        title="Gastos com combustível"
                      />
                    </b-col>

                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Valor outros</label>
                      <VMoeda
                        v-model="audiencia.vlr_desp_outros"
                        placeholder=""
                        title="Demais gastos"
                      />
                    </b-col>

                    <b-col cols="2" class="mb-2 mt-0">
                      <label for="input-registro">Total despesas</label>
                      <VMoeda
                        v-model="audiencia.despesas_total"
                        placeholder=""
                        title="Demais gastos"
                        readonly
                      />
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" class="mb-2">
                      <b-form-textarea
                        id="infoConteudo"
                        v-model="audiencia.detalhamento_despesas"
                        size="sm"
                        rows="2 "
                        placeholder="Detalhamento da(s) despesa(s)"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>

                  <!-- FUNCIONARIO   -->
                  <!-- FUNCIONARIO   -->
                  <!-- FUNCIONARIO   -->
                </b-col>
              </b-col>

              <b-col cols="12">
                <b-button
                  class="mt-3 mb-3"
                  variant="success"
                  block
                  @click="postAudiencia()"
                  >Gravar audiência</b-button
                >
              </b-col>
            </b-row>

            <b-row>
              <!--  GERAR PDF -->

              <!--
                <b-col cols="3">
                  <b-button class="mt-3 mb-3" variant="warning" block  @click=" postPneus()">Gerar PDF</b-button>
                </b-col>
-->
            </b-row>
          </div>
        </div>
      </div>

      <div class="col-5">
        <b-row class="justify-content-center align-items-center">
          <b-card-group
            class="ml-3 mt-3 mb-3 d-flex justify-content-center"
            deck
          >
            <b-card
              class="ml-2"
              style="width: 33rem"
              border-variant="primary"
              header="QUANTIDADE"
              header-bg-variant="primary"
              header-text-variant="white"
              align="center"
            >
              <b-card-text>
                <h2>
                  {{ audiencias.length }}
                </h2>
              </b-card-text>
            </b-card>

            <b-card
              class="ml-2"
              style="width: 33rem"
              border-variant="success"
              header="VALORES GASTOS"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text>
                <h2>
                  {{
                    audiencias
                      .reduce(
                        (total, v) => total + parseFloat(v.despesas_total || 0),
                        0
                      )
                      .toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                  }}
                </h2>
              </b-card-text>
            </b-card>
          </b-card-group>

          <b-col cols="12" class="mb-3">
            <label for="input-busca">Pesquisa no grid</label>
            <b-form-input
              id="buscamonitoramento"
              v-model="search"
              placeholder="Pesquisar por Nº do ticket ou registro do funcionário"
            ></b-form-input>
          </b-col>
        </b-row>
        <div class="col-12">
          <b-row>
            <!--  TABLE DE AUDIENCIAS                               -->
            <b-col class="col-12">
              <b-table
                id="tblMovimento"
                small
                hover
                striped
                sticky-header="762px"
                :items="audiencias"
                :fields="fieldAudiencia"
              >
                <template #cell(audiencia_ini_hr)="data">
                  {{ formatHora(data.item.audiencia_ini_hr) }}
                </template>

                <template #cell(total)="data">
                  {{ formatCurrency2(data.item.vlrcausa) }}
                </template>

                <template slot="cell(actions)" slot-scope="data">
                  <b-button
                    @click="editAudiencia(data.item)"
                    v-b-modal.modal-multi-pneu
                    title="Editar ticket"
                    size="sm"
                    variant="success"
                    class="mr-2"
                  >
                    <i class="fa fa-exclamation-circle"></i>
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- Modal Saldo -->
    <div>
      <b-modal
        ref="modalMultiPreventivaPecas"
        id="modal-multi-preventivaPecas"
        cancel-title="Fechar"
        size="xl"
        title="Controle de saldo disponível"
        no-close-on-esc
        no-close-on-backdrop
      >
        <font color="blue">{{
          "Saldo liberado.: " + formatCurrency2(saldo.valor_liberado)
        }}</font>
        <div>
          <b-table
            v-model="tablepecas"
            small
            hover
            striped
            sticky-header="530px"
            :fields="fieldPleiteado"
            :items="saldofuncionario"
          >
            <template #cell(valor)="data">
              {{ formatCurrency2(data.item.valor) }}
            </template>
          </b-table>
        </div>
        <template #modal-footer="{ cancel }">
          <b-button size="sm" block variant="outline-primary" @click="cancel()">
            Voltar
          </b-button>
        </template>
      </b-modal>
    </div>

    <!-- Modal financeiro -->
    <div>
      <b-modal
        ref="modalIntegracaoFunanceiro"
        id="modal-multi-preventivaPecas"
        cancel-title="Fechar"
        size="xl"
        title="Integração financeira"
        no-close-on-esc
        no-close-on-backdrop
      >
        <font color="blue"></font>
        <div>
          <b-row>
            <b-col cols="4">
              <label for="input-chassifabricante">FORMA DE PAGAMENTO</label>
              <div>
                <b-form-select
                  v-model="processo.tipopagto_id"
                  :options="tipopagtos"
                  class="mb-3"
                  text-field="tipo"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="4">
              <label for="input-chassifabricante">PARCELAS</label>
              <div>
                <b-form-select
                  v-model="processo.parcela_id"
                  :options="parcelas"
                  class="mb-3"
                  text-field="parcela"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2">
              <label for="input-chassifabricante"></label>
              <b-button
                class="mt-2"
                variant="success"
                block
                @click="postFinanceiroParcelas(), postTicketCabecalho()"
                >FINALIZAR</b-button
              >
            </b-col>

            <b-col cols="2">
              <label for="input-chassifabricante"></label>
              <b-button
                class="mt-1 mb-3"
                variant="warning"
                block
                @click="loadParcelasFolha(), gerarPDFLesser()"
                >Gerar PDF</b-button
              >
            </b-col>
          </b-row>
        </div>
        <template #modal-footer="{ cancel }">
          <b-button size="sm" block variant="outline-primary" @click="cancel()">
            Voltar
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import VueTheMask from "vue-the-mask";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";
import NumericInput from "../utilitarios/NumericInput";
import Alerta from "../utilitarios/Alerta";
import VMoeda from "../utilitarios/VMoeda";
import VInputFlutuante from "../utilitarios/VInputFlutuante";

import ConsultaMaterial from "../sambaiba/CF7MaterialConsulta";
import jsPDF from "jspdf";

export default {
  name: "ManutencaoRfiLancamento",

  computed: {
    ...mapState(["user"]),
    itemsFiltered() {
      let valores = [];
      // const values = Object.values(obj);
      valores = this.audiencias.filter((item) => {
        return (
          item.processo.indexOf(this.search) > -1 ||
          item.reclamante_id.indexOf(this.search) > -1
        );
      });
      return valores;
    },
    valorTotal() {
      return this.materiais.valor_venda
        ? this.materiais.valor_venda * this.processo.quantidade + 0.0
        : 0.0;
    },
    formattedValue() {
      return this.formatCurrency(this.processo.folha);
    },

    distinctTicketIdCount() {
      return [...new Set(this.ticketitenscard.map((item) => item.ticket_id))]
        .length;
    },

    formattedTotal() {
      // Verifica se ticketitens é um array
      if (!Array.isArray(this.ticketitens)) {
        console.error("ticketitens não é um array");
        return 0;
      }

      // Calcula o total somando os valores válidos
      const total = this.ticketitens
        .map((v) => {
          const valor = parseFloat(v.valor_total);
          return isNaN(valor) ? 0 : valor; // Substitui valores inválidos por 0
        })
        .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0.0);

      return total; // Retorna o total
    },
  },

  data: function () {
    return {
      nroProcesso: "",
      audiencia: {},
      audiencias: [],
      statuss: [],
      tipos: [],

      mensagem: "",
      tipoMensagem: "msg", // 'msg', 'ale', 'err'
      mensagemVisivel: false, // <- Essa que está faltando!

      //  processo:[],
      processoSintetico: {},
      //processo: [{ numero: '' }], // Inicializa com um objeto contendo um campo 'numero'
      processos: [],
      processo: {
        dt_recebimento: null,
        numero: "",
      },
      fases: [],
      naturezas: [],
      escritoriosatribuido: [],
      escritoriosreclamante: [],
      advogadoAtribuido: [],
      advogadoReclamante: [],
      assuntos: [],
      movimentos: [],
      funcionarios: {
        nome: "",
        funcao: "",
      },

      isModalVisible: false,
      vendas: [],
      venda: {},
      historicoAdmissao: [],
      vendaitem: {},
      formapagtos: [],
      funcionario: {},
      financeiros: [],
      materiais: [],
      tipopagtos: [],
      nroTicket: 0,
      ticketsintetico: [],
      ticketitens: [],
      ticketitenscard: [],
      parcelas: [],
      parcelasfolha: [],
      saldofuncionario: [],
      saldo: [],
      //////////////
      pneus: [],
      pneu: {},
      filiais: [],
      fabricantes: [],
      vidas: [],
      borrachas: [],
      carcacas: [],
      pneussaldo: [],
      value_fornecedor: 0,
      fornecedores: [],

      isLoading: false,
      dt_abertura: "",
      empresas: [],
      filiais: [],

      empresasf: [],
      empresaf: {},
      filialf: {},
      pneus: [],
      operador: [],
      socorrista_carro: [],
      trocado_carro: [],
      socorristas: [],
      pneus: [],
      pneu: {},
      viacep: [],

      value_empresaf: [],

      defeitos: [],
      defeito: {},

      gruposi: [],
      subgruposi: [],
      defeitosi: [],

      gruposd: [],
      subgruposd: [],
      defeitosd: [],

      executante: {},
      executantes: [],
      lider: {},
      lideres: [],

      mode: "save",
      carregando: false,
      atualizando: false,

      grupo: {},
      grupos: [],
      subgrupo: {},
      subgrupos: [],
      defeito: {},
      defeitos: [],

      // gruposd:[],
      gruposd: {},
      subgrupod: {},
      subgruposd: [],
      defeitod: {},

      solicitante: {},
      solicitantes: [],

      socorrista: {},
      linhas: [],

      nropneu: [],

      pneueditdefeito: [],

      situacaojb: [],

      value_carro: "",
      value_carro_socorrista: "",
      value_carro_trocado: "",
      value_cep: "",
      value_solicitante: "",
      value_executante: "",
      value_socorrista: "",
      value_status: [],
      value_statusjb: [],
      value_tipo: [],
      value_lider: "",

      //garagem:{},
      tipos: [],
      search: "",

      lin: {},

      value_garagem: [], // [] lista

      value_observacoes: "",

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      fieldAudiencia: [
        {
          key: "audiencia_ini_dt	",
          label: "Data",
          sortable: true,
          formatter: (value, key, audiencias) => {
            return moment(audiencias.audiencia_ini_dt)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        { key: "audiencia_ini_hr", label: "Horas", sortable: true },

        { key: "status", label: "Status", sortable: true },
        { key: "tipo", label: "Tipo", sortable: true },
        { key: "vlrcausa", label: "R$ Causa", sortable: true },
        { key: "preposto", label: "Preposto", sortable: true },
        { key: "actions", label: "Ações" },
      ],

      fieldPleiteado: [
        { key: "nome", label: "Pleiteado", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data Cadastro",
          sortable: true,
          formatter: (value, key, assuntos) => {
            return moment(assuntos.dt_cadastro)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
      ],

      //////// Histórico de admissão do funcionário que entrou com processo contra a empresa 25/04/2025
      historicoAdmissao: [
        { key: "codigo_erp", label: "Empresa", sortable: true },
        { key: "descricao", label: "Filial", sortable: true },
        { key: "quantidade", label: "Registro", sortable: true },
        { key: "valor_total", label: "Função", sortable: true },
        { key: "valor_total", label: "Admissão", sortable: true },
        { key: "id", label: "Demissão", sortable: true },
      ],
    };
  },

  filters: {
    dataFormatada(dt) {
      return dt.substring(0, 4);
    },
  },

  components: {
    Multiselect,
    LoadingModal,
    VueTheMask,
    NumericInput,
    ConsultaMaterial,
    NumericInput,
    LoadingModal,
    Alerta,
    VMoeda,
    VInputFlutuante,
  },

  methods: {
    formatarMoeda(valor) {
      if (typeof valor !== "number") return "R$ 0,00";
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    formatHora(value) {
      if (!value) return "";
      // Garante que é uma string e corta os segundos
      return value.toString().substring(0, 5); // ex: "08:00"
    },

    loadEmpresa() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFilial() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.filiais = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_filial_erp,
              filial: emp.filial,
              empresa_id: emp.empresa_id,
            };
          });
        })
        .catch(showError);
    },

    getProcessoSintetico(numeroProcesso = null) {
      const processoNumero = numeroProcesso || this.nroProcesso;
      this.isLoading = true;

      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        processo: `${processoNumero}`,
        psg: this.user.psg,
        origem: "processo",
      };

      const url = `${baseApiUrl}/jur/processo`;

      axios
        .get(url, { params })
        .then((res) => {
          if (res.status === 200) {
            this.processo = { ...res.data };
            // Inicializa o valor de nroProcesso com o numero de processo
            if (this.processo) {
              this.nroProcesso = this.nroProcesso;
              this.getAssuntos();
              this.getMovimentos();
              this.getAdvogadoAtribuido();
              this.getAdvogadoReclamante();
              this.getAudienciaStatus();
              this.getAudienciaTipo();
              this.getFuncionario();
              this.isLoading = false;
            }
          } else if (res.status === 404) {
            // processo = {}; // Se quiser resetar, pode deixar essa linha
            this.isLoading = false;
          }
        })
        .catch(showError);
    },

    getAudiencias(numeroProcesso = null) {
      const processoNumero = numeroProcesso || this.nroProcesso;
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        processo: `${processoNumero}`,
        psg: this.user.psg,
        origem: "audiencia",
      };
      const url = `${baseApiUrl}/jur/audiencia`;
      axios
        .get(url, { params })
        .then((res) => {
          if (res.status === 200) {
            this.audiencias = res.data;
            // Inicializa o valor de nroProcesso com o numero de processo
            if (this.audiencias) {
              this.getAudienciaStatus();
              this.getAudienciaTipo();
            }
          } else if (res.status === 404) {
            // processo = {}; // Se quiser resetar, pode deixar essa linha
            this.isLoading = false;
          }
        })
        .catch(showError);
    },

    getAssuntos() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        processo: `${this.nroProcesso}`,
      };
      const url = `${baseApiUrl}/jur/assunto`;
      axios
        .get(url, { params })
        .then((res) => {
          this.assuntos = res.data;
        })
        .catch(showError);
    },

    getMovimentos() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        processo: `${this.nroProcesso}`,
      };
      const url = `${baseApiUrl}/jur/movimento`;
      axios
        .get(url, { params })
        .then((res) => {
          this.movimentos = res.data;
        })
        .catch(showError);
    },

    postAudienciaDatajud() {
      // Garantir que o número do processo seja correto e esteja disponível
      const processoNumero = this.nroProcesso || this.processo?.processo;

      if (!processoNumero) {
        return showError("Número do processo não encontrado");
      }

      this.isLoading = true; // Ative o indicador de carregamento
      let corpo = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        processo: `${processoNumero}`, // Usando o número do processo corretamente
        //psg: this.user.id_empresa == 18 ? 'PSG_ML18_ALLIBUS': this.user.psg, // Usando o PSG conforme a lógica do usuário
        psg: this.user.psg, // Usando o PSG conforme a lógica do usuário
        origem: "processo",
      };

      const url = `${baseApiUrl}/jur/datajud`;

      axios
        .post(url, corpo)
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            // Verifica se a resposta foi bem-sucedida
            this.getProcessoSintetico(processoNumero); // Chama o método com o número de processo
            //   this.isLoading = false; // Desative o indicador de carregamento
          } else if (res.status === 404) {
            // Caso o processo não seja encontrado
            this.processo = {}; // Reseta os dados se necessário
          }
          //    this.isLoading = false; // Desative o indicador de carregamento
        })
        .catch((err) => {
          if (err.response.status === 500) {
            // Exibe a mensagem vinda do backend, se houver
            const msg = err.response.data?.msg || "Funcionário não encontrado";
            this.mostrarMensagem("Banco de dos do cliente fora do ar", "err"); // tipo 'ale' = alerta amarelo
            this.funcionarios = [];
          } else if (
            err.response.status === 400 ||
            err.response.status === 404
          ) {
            const msg = err.response.data?.msg || "Funcionário não encontrado";
            this.mostrarMensagem(msg, "ale");
            this.isLoading = false;
          } else {
            this.mostrarMensagem("Banco de dos do cliente fora do ar", "err"); // tipo 'ale' = alerta amarelo
          }
        });
    },

    async postAudiencia() {
      let corpo = {
        psg: this.user.psg, // Usando o PSG conforme a lógica do usuário
        empresa_id: String(this.user.id_empresa),
        filial_id: String(this.user.id_filial_erp),
        processo_id: this.processo.processo_id || null, // Se numero não existir, será null
        funcionario_id: String(this.user.id_funcionario),
        id: this.audiencia.id || null,
        escritorio_atribuido_id: this.audiencia.escritorio_atribuido_id || null,
        escritorio_atribuido_advogado_id:
          this.audiencia.escritorio_atribuido_advogado_id || null,
        escritorio_reclamante_id:
          this.audiencia.escritorio_reclamante_id || null,
        escritorio_reclamante_advogado_id:
          this.audiencia.escritorio_reclamante_advogado_id || null,

        tipo_id: this.audiencia.tipo_id || null,
        juiz: this.audiencia.juiz || null,
        reclamante_id: this.funcionarios.id_funcionario || null, // Se numero não existir, será null

        preposto: this.audiencia.preposto || null,
        detalhamento_audiencia: this.audiencia.detalhamento_audiencia || null,

        vlrproposta: this.audiencia.vlrproposta.toFixed(2) || null,
        vlrcausa: this.audiencia.vlrcausa.toFixed(2) || null,
        vlrjuizo: this.audiencia.vlrjuizo.toFixed(2) || null,
        vlrsentenca: this.audiencia.vlrsentenca.toFixed(2) || null,
        vlrreclamante: this.audiencia.vlrreclamante.toFixed(2) || null,
        vlrrescisao: this.audiencia.vlrrescisao.toFixed(2) || null,

        testemunha: this.audiencia.testemunha || null,
        vlr_desp_alimentacao:
          this.audiencia.vlr_desp_alimentacao.toFixed(2) || null,
        vlr_desp_transporte:
          this.audiencia.vlr_desp_transporte.toFixed(2) || null,
        vlr_desp_estacionamento:
          this.audiencia.vlr_desp_estacionamento.toFixed(2) || null,
        vlr_desp_combustivel:
          this.audiencia.vlr_desp_combustivel.toFixed(2) || null,
        vlr_desp_outros: this.audiencia.vlr_desp_outros.toFixed(2) || null,
        detalhamento_despesas: this.audiencia.detalhamento_despesas || null,

        audiencia_ini_dt: this.audiencia.audiencia_ini_dt || null,
        audiencia_ini_hr: this.audiencia.audiencia_ini_hr || null,
        audiencia_ter_dt: this.audiencia.audiencia_ter_dt || null,
        audiencia_ter_hr: this.audiencia.audiencia_ter_hr || null,
        beneficiario_id: this.audiencia.beneficiario_id || null,
      };

      const url = `${baseApiUrl}/jur/audiencia`;

      try {
        const res = await axios.post(url, corpo);

        if ([200, 201].includes(res.status)) {
          // Verifica se a resposta foi bem-sucedida
          this.limparCampos();
          this.$toasted.global.defaultSuccess();
          //    this.getProcessoSintetico(nroProcesso);  // Chama o método com o número de processo
          //this.reset()
        } else {
          // Se a resposta não for 200 nem 201, loga o erro ou trata o status
          console.error("Resposta inesperada:", res);
        }
      } catch (error) {
        showError(error); // Lida com qualquer erro na requisição
      }
    },

    getNatureza() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/jur/natureza`;
      axios
        .get(url, { params })
        .then((res) => {
          this.naturezas = res.data.map((na) => {
            return { ...na, value: na.id, grupo: na.status };
          });
        })
        .catch(showError);
    },

    getFase() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_grupo: `${this.defeito.grupo_id}`,
      };
      const url = `${baseApiUrl}/jur/fase`;
      axios
        .get(url, { params })
        .then((res) => {
          this.fases = res.data.map((fa) => {
            return { ...fa, value: fa.id, fase: fa.fase };
          });
        })
        .catch(showError);
    },

    getAudienciaStatus() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_grupo: `${this.defeito.grupo_id}`,
      };
      const url = `${baseApiUrl}/jur/audienciastatus`;
      axios
        .get(url, { params })
        .then((res) => {
          this.statuss = res.data.map((fa) => {
            return { ...fa, value: fa.id, fase: fa.status };
          });
        })
        .catch(showError);
    },

    getAudienciaTipo() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_grupo: `${this.defeito.grupo_id}`,
      };
      const url = `${baseApiUrl}/jur/audienciatipo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tipos = res.data.map((fa) => {
            return { ...fa, value: fa.id, fase: fa.tipo };
          });
        })
        .catch(showError);
    },

    getEscritorioReclamante() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        area_id: 5,
        origem: "reclamante",
        psg: this.user.psg, // O código comentado foi removido
        // psg: this.user.psg,
      };
      const url = `${baseApiUrl}/fin/escritoriojur`;
      axios
        .get(url, { params })
        .then((res) => {
          if (res.status === 200) {
            this.escritoriosreclamante = res.data.map((fa) => {
              return { ...fa, value: fa.id, fase: fa.fantasia };
            });
          } else if (res.status === 404) {
            // Tratar o erro de forma mais explícita
            console.error(
              "Não foi possível encontrar o recurso. Verifique a URL ou os parâmetros."
            );
          }
        })
        .catch(showError); // Presumindo que showError seja uma função definida para exibir erros
    },

    getAdvogadoReclamante() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        empresa_id: `${this.user.id_empresa}`,
        escritorio_id: `${this.processo.escritorio_reclamante_id}`,
        origem: "busca",
        tipo_id: 2,
        psg: this.user.psg, // O código comentado foi removido
        // psg: this.user.psg,
      };
      const url = `${baseApiUrl}/jur/advogados`;
      axios
        .get(url, { params })
        .then((res) => {
          if (res.status === 200) {
            this.advogadoReclamante = res.data.map((fa) => {
              return { ...fa, value: fa.id, fase: fa.nome };
            });
          } else if (res.status === 404) {
            // Tratar o erro de forma mais explícita
            console.error(
              "Não foi possível encontrar o recurso. Verifique a URL ou os parâmetros."
            );
          }
        })
        .catch(showError); // Presumindo que showError seja uma função definida para exibir erros
    },

    getEscritorioAtribuido() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        area_id: 5,
        origem: "atribuido",
        psg: this.user.psg, // O código comentado foi removido
      };
      const url = `${baseApiUrl}/fin/escritoriojur`;
      axios
        .get(url, { params })
        .then((res) => {
          if (res.status === 200) {
            this.escritoriosatribuido = res.data.map((fa) => {
              return { ...fa, value: fa.id, fase: fa.fantasia };
            });
          } else if (res.status === 404) {
            // Tratar o erro de forma mais explícita
            console.error(
              "Não foi possível encontrar o recurso. Verifique a URL ou os parâmetros."
            );
          }
        })
        .catch(showError); // Presumindo que showError seja uma função definida para exibir erros
    },

    async getAdvogadoAtribuido() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        empresa_id: `${this.user.id_empresa}`,
        escritorio_id: `${this.processo.escritorio_atribuido_id}`,
        origem: "busca",
        tipo_id: 1,
        psg: this.user.psg, // O código comentado foi removido
      };

      const url = await `${baseApiUrl}/jur/advogados`;

      axios
        .get(url, { params })
        .then((res) => {
          if (res.status === 200) {
            // Se a resposta for bem-sucedida e contiver dados
            if (res.data && res.data.length > 0) {
              //this.advogadoAtribuido =[]
              this.advogadoAtribuido = res.data.map((fa) => {
                return { ...fa, value: fa.id, fase: fa.nome };
              });
            } else {
              // Caso não haja dados na resposta (por exemplo, nenhum advogado encontrado)
              this.advogadoAtribuido = [];
            }
          } else if (res.status === 404) {
            // Caso a resposta seja 404, sem dados
            console.error(
              "Não foi possível encontrar o recurso. Verifique a URL ou os parâmetros."
            );
            this.advogadoAtribuido = []; // Retorna um array vazio
          }
        })
        .catch(showError); // Presumindo que showError seja uma função definida para exibir erros
    },

    mostrarMensagem(msg, tipo = "msg") {
      this.mensagem = msg;
      this.tipoMensagem = tipo;
      this.mensagemVisivel = true;

      setTimeout(() => {
        console.log("timeout executado");
        this.mensagemVisivel = false;
        this.$forceUpdate(); // força o Vue a atualizar a DOM
      }, 5000);
    },

    getFuncionario() {
      const params = {
        id_empresa: this.user.id_empresa,
        registro: this.processo.registro,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          console.log("Resposta da API:", res); // Verifique se a resposta contém o campo msg
          if (res.status === 200) {
            this.funcionarios = res.data;

            if (this.funcionarios && this.funcionarios.length > 0) {
              this.processo.registro = this.funcionarios.registro;
            }
          }
        })
        .catch((err) => {
          if (err.response.status === 500) {
            // Exibe a mensagem vinda do backend, se houver
            const msg = err.response.data?.msg || "Funcionário não encontrado";
            this.mostrarMensagem("Banco de dos do cliente fora do ar", "err"); // tipo 'ale' = alerta amarelo
            this.funcionarios = [];
          } else if (
            err.response.status === 400 ||
            err.response.status === 404
          ) {
            const msg = err.response.data?.msg || "Funcionário não encontrado";
            this.mostrarMensagem(msg, "ale");
          } else {
            this.mostrarMensagem("Banco de dos do cliente fora do ar", "err"); // tipo 'ale' = alerta amarelo
          }
        });
    },

    calcularTempoDeCasa(admissao, demissao) {
      // Verifica se temos a data de admissão
      if (admissao) {
        const dataAdmissao = moment(admissao);

        // Se não tiver data de demissão, considera a data atual (agora)
        const dataDemissao =
          demissao && moment(demissao).isValid() ? moment(demissao) : moment();

        // Calcula a diferença em anos, meses e dias
        const anos = dataDemissao.diff(dataAdmissao, "years");
        dataAdmissao.add(anos, "years");
        const meses = dataDemissao.diff(dataAdmissao, "months");
        dataAdmissao.add(meses, "months");
        const dias = dataDemissao.diff(dataAdmissao, "days");

        return `${anos} anos, ${meses} meses e ${dias} dias`;
      }
      return "-";
    },

    showModal() {
      this.isModalVisible = true;
    },

    formatCurrency2(value) {
      const number = typeof value === "number" ? value : parseFloat(value);
      if (isNaN(number)) return "R$ 0,00";

      return number.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    async loadProdutos() {
      let corpo = {
        //"empresa_id": `${this.materiais.empresa_id}`,
        codigo_erp: `${this.processo.codigo_erp}`,
        filtro: "CF7",
      };
      const url = `${baseApiUrl}/sambaiba/cf7/produto`;
      axios.post(url, corpo).then((res) => {
        this.materiais = res.data;
      });
    },

    loadNovoNroTicket() {
      const url = `${baseApiUrl}/sambaiba/cf7/nroticket`;
      axios.post(url).then((res) => {
        this.nroTicket = 0;
        this.reset();
        this.nroTicket = res.data.rows.nextval;
      });
    },

    loadComprasFuncionario() {
      // Obtém a data atual no formato YYYY-MM-DD
      const dataAtual = new Date().toISOString().split("T");

      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        re: `${this.processo.re}`,
        dtAtual: dataAtual, // Define a data atual no formato YYYY-MM-DD
        filtro: "saldodisponivel",
      };

      const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.saldofuncionario = res.data; // Atualiza os dados do saldo
          this.loadSaldoLiberado();

          // Abre o modal
          this.$refs.modalMultiPreventivaPecas.show(); // Chama o modal usando a referência
        })
        .catch(showError);
    },

    loadSaldoLiberado() {
      // Obtém a data atual no formato YYYY-MM-DD
      const dataAtual = new Date().toISOString().split("T");

      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        re: `${this.processo.re}`,
        dtAtual: dataAtual, // Define a data atual no formato YYYY-MM-DD
        filtro: "saldo",
      };

      const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.saldo = res.data; // Atualiza os dados do saldo
        })
        .catch(showError);
    },

    ///Tipo de pagamento
    loadTipoPagto() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/sambaiba/cf7/tipopagto`;
      axios
        .get(url)
        .then((res) => {
          this.tipopagtos = res.data.map((sb) => {
            return { ...sb, value: sb.id, tipo: sb.tipo };
          });
        })
        .catch(showError);
    },

    loadParcelas() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/sambaiba/cf7/parcelas`;
      axios
        .get(url)
        .then((res) => {
          this.parcelas = res.data.map((sb) => {
            return { ...sb, value: sb.id, tipo: sb.parcela };
          });
        })
        .catch(showError);
    },

    formatCurrency(value) {
      if (!value) return "";
      value = value.toString().replace(/\D/g, ""); // Remove non-digit characters

      // Ensure at least '0'
      value = value.length ? value : "0";

      if (value.length === 1) return `0,0${value}`;
      if (value.length === 2) return `0,${value}`;

      const integerPart = value.slice(0, -2);
      const decimalPart = value.slice(-2);
      return (
        integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + decimalPart
      );
    },
    convertToDatabaseFormat(value) {
      if (!value) return "0.00";

      // Remove thousand separators (points) and replace the decimal separator (comma) with a dot
      let numericValue = value.toString().replace(/\./g, ""); // Remove all points

      // Find the position of the last comma (if any) and replace it with a dot
      const commaIndex = numericValue.lastIndexOf(",");
      if (commaIndex > -1) {
        numericValue =
          numericValue.slice(0, commaIndex) +
          "." +
          numericValue.slice(commaIndex + 1);
      } else {
        numericValue += ".00"; // If no comma, add '.00'
      }

      // Ensure at least a zero
      return numericValue || "0.00";
    },

    async postTicketCabecalho() {
      const formattedCredit = this.convertToDatabaseFormat(
        this.processo.credito
      );
      let corpo = {
        id_funcionario: `${this.user.id_funcionario_erp}`,
        id: this.nroTicket ? this.nroTicket : this.processo.ticket_id,
        empresa_id: `${this.funcionarios.id_empresa}`,
        filial_id: `${this.funcionarios.id_filial}`,
        funcionario_id: `${this.funcionarios.id_funcionario_erp}`,
        funcao_id: `${this.funcionarios.id_funcao}`,
        pix: `${this.processo.pix / 100}`,
        dinheiro: `${this.processo.dinheiro}`,
        credito: formattedCredit / 100,
        debito: `${this.processo.debito / 100}`,
        vale: `${this.processo.vale / 100}`,
        desconto: `${this.processo.desconto / 100}`,
        total: `${this.formattedTotal}`,
        tipopagto_id: this.processo.tipopagto_id
          ? `${this.processo.tipopagto_id}`
          : null,
        observacao: this.processo.observacao
          ? `${this.processo.observacao}`
          : null,
        filtro: "gravar",
        /*
              "status_id": this.processo.status_id ? `${this.processo.status_id}` : false,
              */
      };
      const url = `${baseApiUrl}/sambaiba/cf7/ticketcabecalho`;
      axios
        .post(url, corpo)
        .then(() => {})
        .catch(showError);
    },

    async postTicketItens() {
      let corpo = {
        id_funcionario: `${this.user.id_funcionario_erp}`,
        ticket_id: this.nroTicket ? this.nroTicket : this.processo.ticket_id,
        id: this.processo.id ? this.processo.id : null,
        empresa_id: `${this.funcionarios.id_empresa}`,
        filial_id: `${this.funcionarios.id_filial}`,
        funcionario_id: `${this.funcionarios.id_funcionario_erp}`,
        produto_id: `${this.materiais.id}`,
        quantidade: `${this.processo.quantidade}`,
        tamanho_id: `${this.materiais.tamanho_id}`,
        cor_id: `${this.materiais.cor_id}`,
        valor_unitario: `${parseFloat(this.materiais.valor_venda)}`,
        //"desconto": `${this.parseFloat(this.processo.desconto)}`,
        valor_total: `${
          parseFloat(this.materiais.valor_venda) *
          parseInt(this.processo.quantidade)
        }`,
        status_id: true, // true-ativo  / false-cancelado
        observacao: `${this.processo.observacao}`,
        rotina_id: 1,
        filtro: "gravar",
      };
      const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.loadTicketItensCard();
          this.loadTicketItens();
          this.loadTicketSintetico();
          this.reset();
        })
        .catch(showError);
    },

    async postFinanceiroParcelas() {
      let corpo = {
        id_funcionario: `${this.user.id_funcionario_erp}`,
        ticket_id: this.nroTicket ? this.nroTicket : this.processo.ticket_id,
        empresa_id: `${this.funcionarios.id_empresa}`,
        filial_id: `${this.funcionarios.id_filial}`,
        funcionario_id: `${this.funcionarios.id_funcionario_erp}`,
        //"dt_emissao": `${this.funcionarios.id_funcao}`,
        //"dt_vencimento": `${this.funcionarios.id_funcao}`,
        parcela_id: `${this.processo.parcela_id}`,
        tipopagto_id: `${this.processo.tipopagto_id}`,
        total: `${this.formattedTotal}`,
        filtro: "gravarparcelas",
      };
      const url = `${baseApiUrl}/sambaiba/cf7/financeiro`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.loadTicketSintetico();
          this.loadParcelasFolha();
          //this.postTicketItens()
          //this.reset()
        })
        .catch(showError);
    },

    loadTicketSintetico() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        filtro: "lancamentodia",
      };
      const url = `${baseApiUrl}/sambaiba/cf7/ticketcabecalho`;
      axios
        .post(url, corpo)
        .then((res) => {
          if (res.status === 200) {
            // Verifica se a resposta foi bem-sucedida
            this.ticketsintetico = res.data; // Atualiza os dados do pneu
          } else if (res.status === 404) {
            // Verifica se o pneu não foi encontrado
            ticketsintetico = {};
          }
        })
        .catch(showError);
    },

    loadTicketItens() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        ticket_id: this.nroTicket
          ? `${this.nroTicket}`
          : `${this.processo.ticket_id}`,
        filtro: "lancamentodia",
      };
      const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
      axios
        .post(url, corpo)
        .then((res) => {
          if (res.status === 200) {
            // Verifica se a resposta foi bem-sucedida
            this.ticketitens = res.data; // Atualiza os dados do pneu
          } else if (res.status === 404) {
            // Verifica se o pneu não foi encontrado
            ticketitens = {};
          }
        })
        .catch(showError);
    },

    loadTicketItensCard() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        filtro: "lancamentodiacard",
      };
      const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
      axios
        .post(url, corpo)
        .then((res) => {
          if (res.status === 200) {
            // Verifica se a resposta foi bem-sucedida
            this.ticketitenscard = res.data; // Atualiza os dados do pneu
          } else if (res.status === 404) {
            // Verifica se o pneu não foi encontrado
            ticketitenscard = {};
          }
        })
        .catch(showError);
    },

    async gerarPDFLesser() {
      try {
        const doc = new jsPDF();
        const startX = 14;
        const startY = 10;
        const fontSize = 8; // Defina o tamanho da fonte desejado

        doc.setFontSize(fontSize); // Define o tamanho da fonte para todos os textos seguintes

        // URL da imagem
        const imageUrl =
          "https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/logotipo/LOGO_SAMBAIBA.png";

        // Função para carregar a imagem a partir da URL
        const loadImage = (url) => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.crossOrigin = "Anonymous"; // Para evitar problemas de CORS
            img.onload = () => resolve(img);
            img.onerror = reject;
          });
        };

        const image = await loadImage(imageUrl);

        // Adicionar tabela com imagem, texto e campos antes do texto 'CF7'
        const tableData = [
          [
            { content: "", image: image, width: 16, height: 16 }, // Primeira coluna: Imagem
            { content: "CF7 STORE" }, // Segunda coluna: Texto
            {
              content:
                (this.nroTicket
                  ? "Nº ticket \n" + this.nroTicket
                  : "Nº ticket \n" + this.processo.ticket_id) +
                "\n" +
                "Data Emissão \n" +
                moment(this.processo.dt_cadastro).format("DD/MM/YYYY HH:mm"), // Formatar a data corretamente
            }, // Terceira coluna: Texto
          ],
        ];

        // Adiciona a primeira tabela
        doc.autoTable({
          startY: startY,
          body: tableData,
          columnStyles: {
            0: { cellWidth: 27, halign: "center", valign: "middle" }, // Tamanho e alinhamento da coluna 0 (Imagem)
            1: { cellWidth: 115, halign: "center", valign: "middle" }, // Tamanho e alinhamento da coluna 1 (Texto)
            2: { cellWidth: 40, halign: "center", valign: "middle" }, // Tamanho e alinhamento da coluna 2 (Texto)
          },
          styles: {
            fillColor: [255, 255, 255], // Fundo branco
            textColor: [0, 0, 0], // Texto preto
            lineColor: [0, 0, 0], // Bordas pretas
            halign: "center", // Centralizar texto horizontalmente
            valign: "middle", // Centralizar texto verticalmente
          },
          tableLineColor: [0, 0, 0], // Bordas pretas
          tableLineWidth: 0.1, // Largura das bordas
          didDrawCell: function (data) {
            if (data.column.index === 0 && data.cell.raw.image) {
              doc.addImage(
                data.cell.raw.image.src,
                "PNG",
                data.cell.x + 2,
                data.cell.y + 2,
                data.cell.raw.width,
                data.cell.raw.height
              );
            }

            // Desenhar linha vertical entre a segunda e terceira colunas
            if (data.column.index === 1) {
              const cell = data.cell;
              doc.setDrawColor(0, 0, 0); // Cor preta para a linha
              doc.setLineWidth(0.1); // Largura da linha
              doc.line(
                cell.x + cell.width,
                cell.y,
                cell.x + cell.width,
                cell.y + cell.height
              );
            }
          },
        });

        // Ajuste o valor de startY para a próxima tabela
        const newTableStartY = doc.autoTable.previous.finalY + 10; // 10 é o espaçamento adicional entre as tabelas

        // Adicionar nova tabela com 1 linha e 3 colunas
        const newTableData = [
          [
            "Registro.:" +
              this.funcionarios["re"] +
              "\n" +
              "Função.: " +
              this.funcionarios["funcao"] +
              "\n" +
              "Nome.: " +
              this.funcionarios["nome"] +
              (this.processo.observacao
                ? "\n" + "Observação.: " + this.processo.observacao
                : ""),
          ],
        ];

        // Posição informações do funcionário
        doc.autoTable({
          startY: newTableStartY - 8,
          body: newTableData,
          columnStyles: {
            0: { cellWidth: 180, halign: "left" }, // Alinhar coluna 0 (Texto) ao centro
            1: { cellWidth: 1, halign: "left" }, // Alinhar coluna 1 (Texto) ao centro
            2: { cellWidth: 1, halign: "left" }, // Alinhar coluna 2 (Texto) ao centro
          },
          styles: {
            fillColor: [255, 255, 255], // Fundo branco
            textColor: [0, 0, 0], // Texto preto
            lineColor: [0, 0, 0], // Bordas pretas
            halign: "center", // Centralizar texto horizontalmente
            valign: "middle", // Centralizar texto verticalmente
          },
          tableLineColor: [0, 0, 0], // Bordas pretas
          tableLineWidth: 0.1, // Largura das bordas
        });

        // Adicionar tabela com parcelasfolha
        const parcelasfolhaData = this.parcelasfolha.map((parcela) => [
          parcela.parcela || "", // Exemplo de dado
          parseFloat(parcela.valor_parcela).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }) || "", // Exemplo de dado
          moment(parcela.dt_vencimento).format("DD/MM/YYYY") || "", // Exemplo de dado
          parcela.tipo_pagto || "", // Exemplo de dado//tipopagtos
        ]);

        const parcelasfolhaHeaders = [
          "Parcela",
          "Valor",
          "Data",
          "Tipo Pagamento",
        ];

        doc.autoTable({
          startY: doc.autoTable.previous.finalY + 50, // TABELA DE PARCELAS
          head: [parcelasfolhaHeaders],
          body: parcelasfolhaData,
          columnStyles: {
            0: { cellWidth: 40, halign: "center" },
            1: { cellWidth: 40, halign: "right" },
            2: { cellWidth: 40, halign: "center" },
            3: { cellWidth: 40, halign: "center" },
          },
          styles: {
            fontSize: 8,
            cellPadding: 2,
            valign: "middle",
            lineColor: [0, 0, 0],
            lineWidth: 0.1,
          }, // Adicionar bordas pretas
          headStyles: { fontStyle: "bold" },
          didDrawCell: function (data) {
            const cell = data.cell;
            const doc = data.doc;
            doc.rect(cell.x, cell.y, cell.width, cell.height, "S"); // Desenhar as bordas
          },
        });

        // Cabeçalhos da tabela
        const headers = [
          "Item",
          "Código",
          "Descrição",
          "Quantidade",
          "Valor unitário",
          "Total",
        ];

        // Preparar os dados para o PDF com formatação de moeda
        const dadosParaPDF = this.ticketitens.map((item, index) => {
          const valorUnitario = parseFloat(item.valor_unitario) || 0;
          const quantidade = parseFloat(item.quantidade) || 0;
          const total = valorUnitario * quantidade;
          const totalgeral = valorUnitario * quantidade;

          return [
            index + 1, // Adiciona o índice (começando de 1 para ser mais intuitivo)
            item.codigo_erp || "", // Coluna 2: Código
            item.descricao || "", // Coluna 3: Descrição
            quantidade, // Coluna 4: Quantidade
            valorUnitario.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            }), // Coluna 5: Valor unitário formatado
            total.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            }), // Coluna 6: Total formatado
            totalgeral,
          ];
        });

        // Calcular a soma total geral
        const somaTotal = dadosParaPDF.reduce((acumulador, linha) => {
          // Utiliza linha[5] que contém o total como número não formatado
          const valorTotal = parseFloat(linha[6]) || 0;
          return acumulador + valorTotal;
        }, 0);

        // Adicionar a soma total geral no final
        dadosParaPDF.push([
          "Total Geral", // Texto para a coluna de índice
          "", // Coluna 2: Vazio para o código
          "", // Coluna 3: Vazio para a descrição
          "", // Coluna 4: Vazio para a quantidade
          "", // Coluna 5: Vazio para o valor unitário
          somaTotal.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }), // Coluna 6: Total Geral formatado
        ]);

        // Número de linhas por página
        const rowsPerPage = 12;

        for (let i = 0; i < dadosParaPDF.length; i += rowsPerPage) {
          const currentData = dadosParaPDF.slice(i, i + rowsPerPage);

          if (i > 0) {
            doc.addPage();
          }

          doc.autoTable({
            startY: 50,
            head: [headers],
            body: currentData,
            theme: "plain",
            columnStyles: {
              0: { cellWidth: 20, halign: "center" }, // Alinhar coluna 0 (Item) ao centro
              1: { cellWidth: 20, halign: "center" }, // Alinhar coluna 1 (Código) ao centro
              2: { cellWidth: 62, halign: "left" }, // Alinhar coluna 2 (Descrição) à esquerda
              3: { cellWidth: 20, halign: "right" }, // Alinhar coluna 3 (Quantidade) à direita
              4: { cellWidth: 30, halign: "right" }, // Alinhar coluna 4 (Valor unitário) à direita
              5: { cellWidth: 30, halign: "right" }, // Alinhar coluna 5 (Total) à direita
            },
            styles: {
              fontSize: 8,
              cellPadding: 2,
              valign: "middle",
              lineColor: [0, 0, 0],
              lineWidth: 0.1,
            }, // Adicionar bordas pretas
            headStyles: { fontStyle: "bold" },
            didDrawCell: function (data) {
              const cell = data.cell;
              const doc = data.doc;
              doc.rect(cell.x, cell.y, cell.width, cell.height, "S"); // Desenhar as bordas
            },
          });
        }

        const pageCount = doc.internal.getNumberOfPages();
        const footerFontSize = 6; // Defina o tamanho da fonte para o rodapé

        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          const footerX = 10;
          const footerY = doc.internal.pageSize.height - 10;
          const currentDate = moment().format("DD/MM/YYYY - HH:mm");
          const pageNumber = "Página " + i + " de " + pageCount;
          const footerText = "Data: " + currentDate + " | " + pageNumber;

          doc.setFontSize(footerFontSize); // Define o tamanho da fonte
          doc.text(footerText, footerX, footerY);

          // Verifica se estamos na última página
          if (i === pageCount) {
            const assinaturaY = footerY - 10; // Ajuste conforme necessário
            doc.text(
              "____________________________________________________________________",
              footerX,
              assinaturaY - 5
            );
            doc.text(
              "Assinatura: " +
                this.funcionarios["nome"] +
                "-" +
                this.funcionarios["funcao"],
              footerX,
              assinaturaY
            );
          }
        }

        doc.save(
          "Ticket_" +
            this.processo.ticket_id +
            "_funcionario_" +
            this.funcionarios["re"] +
            ".pdf"
        );
      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
      }
    },

    loadParcelasFolha() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        ticket_id: this.nroTicket
          ? `${this.nroTicket}`
          : `${this.processo.ticket_id}`,
      };
      const url = `${baseApiUrl}/sambaiba/cf7/financeiro/folha`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.parcelasfolha = res.data;
        })
        .catch(showError);
    },

    limparFiltro() {
      this.search = "";
    },

    ///CHASSI FABRICANTE
    loadFabricante() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/fabricante`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.fabricantes = res.data.map((gru) => {
            return { ...gru, value: gru.id, fabricante: gru.fabricante };
          });
        })
        .catch(showError);
    },

    loadVida() {
      const url = `${baseApiUrl}/pneu/vida`;
      axios
        .get(url)
        .then((res) => {
          this.vidas = res.data.map((sb) => {
            return { ...sb, value: sb.id, vida: sb.vida };
          });
        })
        .catch(showError);
    },

    loadBorracha() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/borracha`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.borrachas = res.data.map((gru) => {
            return { ...gru, value: gru.id, borracha: gru.borracha };
          });
        })
        .catch(showError);
    },

    loadCarcaca() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/desenho`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.carcacas = res.data.map((gru) => {
            return { ...gru, value: gru.id, desenho: gru.desenho };
          });
        })
        .catch(showError);
    },

    loadStattus() {
      const url = `${baseApiUrl}/pneu/status`;
      axios
        .get(url)
        .then((res) => {
          this.statuss = res.data.map((gru) => {
            return { ...gru, value: gru.id, status: gru.status };
          });
        })
        .catch(showError);
    },

    ///////////////////////////////// 31/12/2022 as 20:17h
    editTicketResumo(venda) {
      this.venda = { ...venda };
      //this.loadTicketItens()
      //this.loadFuncionario()
      //this.loadProdutos()
    },

    ///////////////////////////////// 31/12/2022 as 20:17h
    editAudiencia(audiencia) {
      this.audiencia = { ...audiencia };
      this.getAudiencias();
      this.getAudienciaTipo();
    },

    loadPneuSaldo() {
      let corpo = {
        empresa_id: `${[this.pneu.empresa_id]}`,
        filial_id: `${[this.pneu.filial_id]}`,
        origem: "websaldo",
      };
      const url = `${baseApiUrl}/pneu/pneu`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.pneussaldo = res.data;
        })
        .catch(showError);
    },

    reset() {
      this.processo = {
        registro: "",
        vlrcausa: null,
        tribunal: "",
        // deve bater com a estrutura inicial
      };

      this.funcionarios = [];
    },

    limparCampos() {
      console.log("Limpando campos");
      this.processo = {};
      this.funcionarios = {};
      this.processo = {};
      this.audiencia = {};
    },

    novo() {
      this.pneu = {};
      this.defeito = {};
      this.pneueditdefeito = {};
    },

    loadPneuFornecedores() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
        origem: "listagem",
      };
      const url = `${baseApiUrl}/fin/clifor`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.fornecedores = res.data.map((gru) => {
            return { ...gru, value: gru.id, nome: gru.nome };
          });
        })
        .catch(showError);
    },
  },

  mounted() {
    this.getFase();
    this.getNatureza();
    this.getEscritorioAtribuido();
    this.getEscritorioReclamante();
    // this.getAdvogadoAtribuido()
    //this.getAdvogadoReclamante()
    /*
      this.loadEmpresa() 
      this.loadFilial()
      this.loadTipoPagto() 
      this.loadTicketSintetico()   
      this.loadTicketItensCard()
      this.loadParcelas()
      */

    /*
      this.loadFabricante()      
      this.loadVida()
      this.loadBorracha()      
      this.loadCarcaca()
      this.loadStattus()
      this.loadPneuFornecedores()
      */
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#processoNatureza {
  font-size: 15px;
  text-align: center;
}

#processoFase {
  font-size: 15px;
  text-align: center;
}

#placa {
  font-size: 0.7em;
}

#cardvalorticket {
  font-size: 1.3em;
}

#modal-multi-pneu___BV_modal_content_ {
  background: rgb(227, 236, 227);
  /* border: 1px solid rgb(58, 20, 196) ; */
  border-radius: 8px;
  margin-bottom: 4px;
}

#defeito-selecao {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-sos {
  background: rgb(199, 222, 218);
  border: 1px solid red;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-informado {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-diagnosticado {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-encerramento {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2);
  border-radius: 8px;
  margin-bottom: 4px;
}

#pneu-nro {
  color: rgb(240, 8, 8);
  font-size: 18px;
  text-align: center;
}

/* Define a altura e a largura da imagem */
.img-custom {
  width: 150px; /* Ajuste conforme necessário */
  height: 150px; /* Ajuste conforme necessário */
  object-fit: cover; /* Garante que a imagem cubra a área sem distorcer */
}

.alert-container {
  position: fixed; /* Fixa o elemento na tela */
  top: 50%; /* Move o elemento para o meio verticalmente */
  left: 50%; /* Move o elemento para o meio horizontalmente */
  transform: translate(
    -50%,
    -50%
  ); /* Ajusta a posição para o centro do elemento */
  z-index: 1000; /* Garante que o alerta ficará sobre outros conteúdos */
}

#divisao {
  border: 0;
  height: 4px;
  background: #1405ee; /* Cor da linha */
  margin: 20px 0; /* Espaço acima e abaixo da linha */
}

.alert-container {
  width: 78%;
  padding: 0;
  margin: 0;
}

.full-width-alert {
  width: 100%;
  box-sizing: border-box; /* Garante que padding e bordas não afetam a largura total */
}

/* Para centralizar o texto no alerta */
.full-width-alert .alert-content {
  text-align: center;
}

.custom-alert-text {
  font-size: 1.44rem; /* Ajuste o tamanho da fonte conforme necessário */
  text-align: center; /* Garante que o texto está centralizado */
}
</style>